import React, { PureComponent } from 'react';
import './index.scss';
import { showShareMenu } from '../CrgtEvent';
import emitter from '@/utils/events';
import { trackPVByActivity } from '@/utils/util';
import { videoShare } from '@/services/api';
import {Toast} from 'antd-mobile';
export default class Share extends PureComponent {
  state = {
    isShared: false,
    enableShare: false
  }
  componentDidMount = () => {

    this.eventEmitter = emitter.addListener('SharedForChance', ({ isShared, enableShare }) => {
      this.setState({ isShared, enableShare })
    });
  }
componentWillReceiveProps(nextProps) {
  if(this.props.shareInfo !== nextProps.shareInfo && (!_.isNil(nextProps.shareInfo))){
    this.initWX(nextProps)
  }
}
  initWX(nextProps) {
    const { isWX } = window.crgt;
    const { shareInfo } = nextProps;
   console.log('share shareinfo', {...shareInfo, success:() => this.grantChance(isShared, enableShare, () => this.getChanceByShareRefreshData())})
    if (isWX) {
      window.crgt.share.setShareInfo({...shareInfo, success:() => this.grantChance(isShared, enableShare, () => this.getChanceByShareRefreshData())})
    }
  }

  componentWillUnmount() {
    if (this.eventEmitter) {
      emitter.removeListener(this.eventEmitter);
    }
  }


  getChanceByShare = async ()=> {
    const { shareInfo } = this.props;
    console.log(shareInfo)
    const { isShared, enableShare } = this.state;
    showShareMenu(shareInfo, () => this.grantChance(isShared, enableShare, () => this.getChanceByShareRefreshData()))
  }

  async grantChance(isShared, enableShare, refreshData) {
    console.log('grant chance', isShared, enableShare, refreshData)
    trackPVByActivity('20190903_4')
    if (!enableShare) return;
    if (isShared) return;
    const token = await window.crgt.getToken();
    if (token) {
      const res = await videoShare();
      if (res.code === 0) {
        if (res.data) {
          Toast.info('恭喜获得机会', 2, () => refreshData && refreshData());
        }
      }
    }
  }

  getChanceByShareRefreshData() {
    console.log('share emit function')
    emitter.emit('fetchDrawInfo', '');
  }

  render() {
    const { shareBgImageUrl, shareButtonImageUrl } = this.props;

    return (<div className="share-container">
      <img className="share-bg" src={shareBgImageUrl} />
      {typeof window !== 'undefined' && window.crgt.isCRGT && <img className="share-button" src={shareButtonImageUrl} onClick={this.getChanceByShare} />}
    </div>)
  }
}